// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"30":"9ce78906","317":"5282dd2d","608":"86c7ef93","669":"1a9ceeab"}[chunkId] + ".chunk.js";
};